export const AudienceRoute = {
  AUDIENCES: '/audiences',
  AUDIENCES_ARCHIVED: '/audiences/archivedaudiences/:id',

  TARGET: '/audiences/target/:client',
  TARGET_DETAILS: '/audiences/target/:client/:id',
  SELECTION: '/audiences/selection',
  DETAILS: '/audiences/details/:id',
  MAPPING: '/audiences/mapping',
  TARGET_MAIN: '/audiences/target',
  TARGET_DETAILS_ACTION: '/audiences/target/:client/:id/:action',

  TARGET_V2: '/audiences/target-v2/:client',
  TARGET_DETAILS_V2: '/audiences/target-v2/:client/:id',
  DETAILS_V2: '/audiences/details-v2/:id',
  MAPPING_V2: '/audiences/mapping-v2/:action',
  MAPPING_V2_DETAILS: '/audiences/mapping-v2/:client/:id/:action',
  TARGET_MAIN_V2: '/audiences/target-v2',
  TARGET_DETAILS_ACTION_V2: '/audiences/target-v2/:client/:id/:action',
};

export const minCountRequiredForCreateAudience = 500;
export const maxSuppressionCount = 6;

export const GeoOptions = {
  CBSA: 'cbsa',
  CITY_STATE: 'city_state',
  COUNTY_CODE: 'county_code',
};

export const AudienceName = {
  AUDIENCES: 'audiences',
  AUDIENCES_ARCHIVED: 'audiences-archived',
  TARGET: 'audiences-target',
  SELECTION: 'audiences-selection',
  DETAILS: 'audiences-details',
  MAPPING: 'audiences-mapping',
};

export const ModalType = {
  TARGET: 'TARGET',
  DETAILS: 'DETAILS',
};

export const InputType = {
  CHECKBOX: 'Checkbox',
  SEARCH: 'Search',
  SLIDER: 'Slider',
  TEXT: 'text',
};

export const Common = {
  UNDEFINED: 'undefined',
  MACROS_URL: 'macros_url',
  CUSTOM_URL: 'CUSTOM_URL',
};

export const FileName = {
  EDIT: 'edit.png',
  LOADER: 'loader.png',
  FAILED: 'failed.png',
  SUCCESS: 'success.png',
  READY: 'ready.png',
  REFRESH: 'refresh1.png',
  ARCHIVE: 'archive.png',
  EXPIRED: 'expired.png',
};

export const Status = {
  DRAFT: 'DRAFT',
  COUNT_REQUEST_RUNNING: 'COUNT_REQUEST_RUNNING',
  COUNT_REQUEST_ERROR: 'COUNT_REQUEST_ERROR',
  COUNT_REQUEST_SUCCESS: 'COUNT_REQUEST_SUCCESS',
  COUNT_REQUEST_TIME_OUT: 'COUNT_REQUEST_TIME_OUT',
  AUDIENCE_RUNNING: 'AUDIENCE_RUNNING',
  AUDIENCE_ERROR: 'AUDIENCE_ERROR',
  AUDIENCE_CURRENT: 'AUDIENCE_CURRENT',
  AUDIENCE_EXPIRED: 'AUDIENCE_EXPIRED',
  AUDIENCE_OBSOLETE_TAXONOMY: 'AUDIENCE_OBSOLETE_TAXONOMY',
  ARCHIVED: 'ARCHIVED',
  CHECK_CSV_RUNNING: 'CHECK_CSV_RUNNING',
  CHECK_CSV_ERROR: 'CHECK_CSV_ERROR',
  CHECK_CSV_SUCCESS: 'CHECK_CSV_SUCCESS',
};

export const ERROR_TOAST_DURATION = 10000;

export const ColumnMappings = [
  {
    name: 'First Name',
    key: 'first_name',
    item: { selected: '', values: [] },
    error: '',
    groupRequired: ['last_name', 'address1'],
    exclusionAllowed: true,
    optionsAvailable: ['zip5', 'zip4', 'zip9'],
  },
  {
    name: 'Last Name',
    key: 'last_name',
    item: { selected: '', values: [] },
    error: '',
    groupRequired: ['first_name', 'address1'],
    exclusionAllowed: true,
    optionsAvailable: ['zip5', 'zip4', 'zip9'],
  },
  {
    name: 'Address 1',
    key: 'address1',
    item: { selected: '', values: [] },
    error: '',
    groupRequired: ['first_name', 'last_name'],
    exclusionAllowed: true,
    optionsAvailable: ['zip5', 'zip4', 'zip9'],
  },
  {
    name: 'Address 2',
    key: 'address2',
    item: { selected: '', values: [] },
    error: '',
    groupRequired: ['address1'],
  },
  {
    name: 'Zip 5',
    key: 'zip5',
    item: { selected: '', values: [] },
    error: '',
    groupRequired: ['first_name', 'last_name', 'address1'],
    exclusionAllowed: true,
  },
  {
    name: 'Zip 4',
    key: 'zip4',
    item: { selected: '', values: [] },
    error: '',
    groupRequired: ['first_name', 'last_name', 'address1'],
    exclusionAllowed: true,
  },
  {
    name: 'Zip 9',
    key: 'zip9',
    item: { selected: '', values: [] },
    error: '',
    groupRequired: ['first_name', 'last_name', 'address1'],
    exclusionAllowed: true,
  },
  {
    name: 'Email',
    key: 'email',
    item: { selected: '', values: [] },
    error: '',
  },
  {
    name: 'Email MD5',
    key: 'md5_email',
    item: { selected: '', values: [] },
    error: '',
  },
  {
    name: 'Lower Email MD5 Hash',
    key: 'lower_email_md5',
    item: { selected: '', values: [] },
    error: '',
  },
  {
    name: 'Upper Email MD5 Hash',
    key: 'upper_email_md5',
    item: { selected: '', values: [] },
    error: '',
  },
  {
    name: 'Lower Email SHA256 Hash',
    key: 'lower_email_sha256',
    item: { selected: '', values: [] },
    error: '',
  },
  {
    name: 'Upper Email SHA256 Hash',
    key: 'upper_email_sha256',
    item: { selected: '', values: [] },
    error: '',
  },
  {
    name: 'Lower Email SHA1 Hash',
    key: 'lower_email_sha1',
    item: { selected: '', values: [] },
    error: '',
  },
  {
    name: 'Upper Email SHA1 Hash',
    key: 'upper_email_sha1',
    item: { selected: '', values: [] },
    error: '',
  },
  {
    name: 'Device ID',
    key: 'device_id',
    item: { selected: '', values: [] },
    error: '',
  },
  {
    name: 'Person ID',
    key: 'person_id',
    item: { selected: '', values: [] },
    error: '',
  },
];

export const AudienceType = {
  MATCH_AND_ACTIVATE: 'Match and Activate',
};

export const TargetType = {
  INDIVIDUAL: 'individual',
  HOUSEHOLD: 'household',
};

export const StatusName = {
  DRAFT: 'Draft',
  COUNT_REQUEST_RUNNING: 'Count Running',
  COUNT_REQUEST_ERROR: 'Count Failed',
  COUNT_REQUEST_SUCCESS: 'Count Success',
  COUNT_REQUEST_TIME_OUT: 'Count Timed Out',
  AUDIENCE_RUNNING: 'Running',
  AUDIENCE_ERROR: 'Failed',
  AUDIENCE_CURRENT: 'Ready',
  AUDIENCE_EXPIRED: 'Needs Refresh',
  AUDIENCE_OBSOLETE_TAXONOMY: 'Obsolete',
  ARCHIVED: 'Archived',
  CHECK_CSV_RUNNING: 'Checking File',
  CHECK_CSV_ERROR: 'File Errors',
  CHECK_CSV_SUCCESS: 'File Ready to Map',
};

export const STATES = [
  { id: 'AL', value: 'Alabama' },
  { id: 'AK', value: 'Alaska' },
  { id: 'AZ', value: 'Arizona' },
  { id: 'AR', value: 'Arkansas' },
  { id: 'CA', value: 'California' },
  { id: 'CO', value: 'Colorado' },
  { id: 'CT', value: 'Connecticut' },
  { id: 'DE', value: 'Delaware' },
  { id: 'DC', value: 'District of Columbia' },
  { id: 'FL', value: 'Florida' },
  { id: 'GA', value: 'Georgia' },
  { id: 'HI', value: 'Hawaii' },
  { id: 'ID', value: 'Idaho' },
  { id: 'IL', value: 'Illinois' },
  { id: 'IN', value: 'Indiana' },
  { id: 'IA', value: 'Iowa' },
  { id: 'KS', value: 'Kansas' },
  { id: 'KY', value: 'Kentucky' },
  { id: 'LA', value: 'Louisiana' },
  { id: 'ME', value: 'Maine' },
  { id: 'MD', value: 'Maryland' },
  { id: 'MA', value: 'Massachusetts' },
  { id: 'MI', value: 'Michigan' },
  { id: 'MN', value: 'Minnesota' },
  { id: 'MS', value: 'Mississippi' },
  { id: 'MO', value: 'Missouri' },
  { id: 'MT', value: 'Montana' },
  { id: 'NE', value: 'Nebraska' },
  { id: 'NV', value: 'Nevada' },
  { id: 'NH', value: 'New Hampshire' },
  { id: 'NJ', value: 'New Jersey' },
  { id: 'NM', value: 'New Mexico' },
  { id: 'NY', value: 'New York' },
  { id: 'NC', value: 'North Carolina' },
  { id: 'ND', value: 'North Dakota' },
  { id: 'OH', value: 'Ohio' },
  { id: 'OK', value: 'Oklahoma' },
  { id: 'OR', value: 'Oregon' },
  { id: 'PA', value: 'Pennsylvania' },
  { id: 'RI', value: 'Rhode Island' },
  { id: 'SC', value: 'South Carolina' },
  { id: 'SD', value: 'South Dakota' },
  { id: 'TN', value: 'Tennessee' },
  { id: 'TX', value: 'Texas' },
  { id: 'UT', value: 'Utah' },
  { id: 'VT', value: 'Vermont' },
  { id: 'VA', value: 'Virginia' },
  { id: 'WA', value: 'Washington' },
  { id: 'WV', value: 'West Virginia' },
  { id: 'WI', value: 'Wisconsin' },
  { id: 'WY', value: 'Wyoming' },
];

export const UPLOAD_CHUNK_SIZE = 5 * 1024 * 1024; // AWS default chunk size, though we could use anything, but this is a good value.

export const BASE64 = 'base64';

export const SUPPRESSION_FILE = 'Suppression file';
export const MATCH_AND_ACTIVATE_UPLOAD_LABEL = 'Match and Activate File Upload Progress';

export const PREFERENCES = 'preferences';
export const RECORDS = {
  TOTAL_RECORDS: ' Total Records',
};

export const ICON = {
  SUPPRESS: 'suppress.png',
  NON_SUPPRESS: 'non-suppress.png',
};
